/* eslint-disable @typescript-eslint/no-explicit-any */
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
export default function (
  func: Function,
  wait = 166
): {
  (...args: any[]): void
  clear(): void
} {
  let timeout: any
  const debounced = (...args: any[]) => {
    const later = () => {
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }

  debounced.clear = () => {
    clearTimeout(timeout)
  }

  return debounced
}
